import { render, staticRenderFns } from "./TenantEditBooking.vue?vue&type=template&id=36eca220&scoped=true&"
import script from "./TenantEditBooking.vue?vue&type=script&lang=js&"
export * from "./TenantEditBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eca220",
  null
  
)

export default component.exports